import Service from "@/domain/Service";
import HttpClient from "../infra/HttpClient";

export default class ServicesService {

    constructor (readonly httpClient: HttpClient, readonly baseUrl: string) {
    }

    async getServices (): Promise<any> {
        return this.httpClient.get(`${this.baseUrl}/services`);
    }

    async saveService(service: Service): Promise<any> {
        return this.httpClient.post(`${this.baseUrl}/services`, service);
    }

	async updateService(service: any): Promise<any> {
        return this.httpClient.put(`${this.baseUrl}/services/${service.idService}`, service);
    }

	async getService(idService: number): Promise<any> {
		return this.httpClient.get(`${this.baseUrl}/services/${idService}`);
	}

	async getServiceStatistics(idService: number): Promise<any> {
		return this.httpClient.get(`${this.baseUrl}/services/${idService}/statistics`);
	}
}
